module.exports = __webpack_public_path__ + "img/payed-true.4ecefe52.svg";